import { render } from "./NavbarLink.vue?vue&type=template&id=2d215a7d&scoped=true"
import script from "./NavbarLink.vue?vue&type=script&lang=js"
export * from "./NavbarLink.vue?vue&type=script&lang=js"

import "./NavbarLink.vue?vue&type=style&index=0&id=2d215a7d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d215a7d"]])

export default __exports__